import i18n from '@src/lang';

export default function formatErrorMessage(errorStatus) {
  return i18n.t(`error.${errorStatus}`) || errorStatus
}

export function formatSuccessMessage(successStatus) {
  return i18n.t(`success.${successStatus}`) || successStatus
}
